// export const BASE_URL = "http://52.66.236.213:9292/";
// export const BASE_URL = "http://52.66.236.213:9000/";
// export const BASE_URL = "https://admin.parsal.in:9001/";
export const BASE_URL = "https://api.parsal.in:9001/";
// export const BASE_URL = "http://192.168.29.93:9292/";

//   "homepage": "http://52.66.236.213/parsal/web/", in package.json
